import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { content } from '../data/content';
import { PRODUCT, formatPrice, packTotal } from '../data/product';
import { orderPath } from './ui/Ui';

/**
 * شريط ثابت أسفل الشاشة: يبقي زر الطلب في متناول الإبهام مهما نزل العميل،
 * ويحمل معه الباقة المختارة من قسم العرض.
 */
export default function StickyCta({ pack }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // عتبة منخفضة: الزر يظهر بمجرد أن يمرّر المستخدم قليلاً
    const onScroll = () => setVisible(window.scrollY > 320);

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={`fixed bottom-0 inset-x-0 z-50 transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      {/* خلفية بيضاء مصمتة لا شفافة: مع الشفافية يمتزج لون المحتوى المارّ خلف
          الشريط بالنص فتتغيّر نسبة التباين حسب موضع التمرير */}
      <div className="bg-white border-t border-gray-200 shadow-md px-4 py-3 flex items-center gap-3 md:gap-4">
        <div className="shrink-0">
          <p className="text-[10px] text-z-gray leading-none mb-1">{content.stickyPrice}</p>
          <p className="flex items-baseline gap-2">
            <span className="text-xl font-bold text-z-navy leading-none">{formatPrice(packTotal(pack))}</span>
            {/* يُخفى إن لم يكن أعلى من السعر الحالي — سعر مشطوب أرخص يناقض نفسه */}
            {pack.qty * PRODUCT.oldPrice > packTotal(pack) && (
              <span className="text-xs text-z-gray line-through">{formatPrice(pack.qty * PRODUCT.oldPrice)}</span>
            )}
          </p>
        </div>

        <Link
          to={orderPath(pack.id)}
          className="flex-1 bg-z-red text-white py-3.5 font-bold rounded-full transition-all flex items-center justify-center gap-2 shadow-lg shadow-z-red/30"
        >
          <i className="fa-solid fa-bag-shopping" /> {content.stickyCta}
          <span className="hidden sm:inline">— {content.trustCod}</span>
        </Link>
      </div>
    </div>
  );
}
